import { createAction, props } from '@ngrx/store';

export const setUser = createAction('[stage] Setting user', props<{ user: string }>())

export const setProject= createAction('[stage] Setting project', props<{ projectId: string }>())

export const setProjectSuccess= createAction('[stage] Setting project SUCCESS',props<{ project: any }>())

export const setProjectError= createAction('[stage] Setting project ERROR', props<{ error: any }>())